import {
	CREATE_ARTICLES_PROPS_CHANGED,
	CREATE_ARTICLE_SET_ARTICLE_TO_EDIT,
	CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS,
	CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_SUCCESS,
	CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_FAILURE,
	CREATE_ARTICLES_SAVE_ARTICLE,
	CREATE_ARTICLES_SAVE_ARTICLE_SUCCESS,
	CREATE_ARTICLES_SAVE_ARTICLE_FAILURE,
	CREATE_ARTICLES_SUBMIT_ARTICLE,
	CREATE_ARTICLES_SUBMIT_ARTICLE_SUCCESS,
	CREATE_ARTICLES_SUBMIT_ARTICLE_FAILURE,
	CREATE_ARTICLES_APPROVE_ARTICLE,
	CREATE_ARTICLES_APPROVE_ARTICLE_SUCCESS, CREATE_ARTICLES_APPROVE_ARTICLE_FAILURE,
} from "./actions";
import {defaultArticleState, initialState} from "./reducer";
import {editorHasText} from "../../../../actions";
import {find} from "../../../../utility/functions";


export const dispatchOnCreateArticlesGetSchoolArticlesLayouts = () => dispatch => {
	dispatch({type: CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS})
};

export const dispatchOnCreateArticlesGetSchoolArticlesLayoutsSuccess = (layouts) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_SUCCESS,
		layouts
	})
};

export const dispatchOnCreateArticlesGetSchoolArticlesLayoutsFailure = () => dispatch => {
	dispatch({type: CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_FAILURE})
};

export const dispatchOnCreateArticlesSaveArticle = () => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_SAVE_ARTICLE
	})
};

export const dispatchOnCreateArticlesSaveArticleSuccess = () => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_SAVE_ARTICLE_SUCCESS
	})
};

export const dispatchOnCreateArticlesSaveArticleFailure = () => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_SAVE_ARTICLE_FAILURE
	})
};

export const dispatchOnCreateArticlesSubmitArticle = () => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_SUBMIT_ARTICLE
	})
};

export const dispatchOnCreateArticlesSubmitArticleSuccess = () => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_SUBMIT_ARTICLE_SUCCESS
	})
};

export const dispatchOnCreateArticlesSubmitArticleFailure = () => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_SUBMIT_ARTICLE_FAILURE
	})
};

export const dispatchOnCreateArticlesApproveArticle = () => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_APPROVE_ARTICLE
	})
};

export const dispatchOnCreateArticlesApproveArticleSuccess = () => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_APPROVE_ARTICLE_SUCCESS
	})
};

export const dispatchOnCreateArticlesApproveArticleFailure = () => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_APPROVE_ARTICLE_FAILURE
	})
};

export const dispatchOnCreateArticlesStraplineChanged = (strapline) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		strapline,
		hasUnsavedChanges: strapline !== initialState.strapline,
	})
};

export const dispatchOnCreateArticlesTitleChanged = (title) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		title,
		hasUnsavedChanges: title !== initialState.title,
	})
};

export const dispatchOnCreateArticlesLeadChanged = (lead) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		lead,
		hasUnsavedChanges: lead !== initialState.lead,
	})
};

export const dispatchOnCreateArticlesBodyChanged = (body) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		body,
		hasUnsavedChanges: editorHasText(body),
	})
};

export const dispatchOnCreateArticlesLayoutChanged = (layout) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		layout,
		hasUnsavedChanges: layout !== initialState.layout,
	})
};

export const dispatchOnCreateArticlesMainImageChanged = (mainImage) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		mainImage,
		hasUnsavedChanges: mainImage !== initialState.mainImage,
	})
};

export const dispatchOnCreateArticlesPublishDateChanged = (publishedDate) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		publishedDate,
		hasUnsavedChanges: publishedDate !== initialState.publishedDate,
	})
};

export const dispatchOnCreateArticlesAuthorChanged = (author) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		author,
		hasUnsavedChanges: author !== initialState.author,
	})
};

export const dispatchOnCreateArticlesImagesChanged = (images) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		images,
		hasUnsavedChanges: images !== initialState.images,
	})
};

export const dispatchOnCreateArticlesArticleToEditChanged = (articleToEdit) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		articleToEdit,
		hasUnsavedChanges: articleToEdit !== initialState.articleToEdit,
	})
};

export const dispatchOnCreateArticlesSetArticleToEditChanged = (articleToEdit) => dispatch => {
	dispatch({
		type: CREATE_ARTICLE_SET_ARTICLE_TO_EDIT,
		articleToEdit: articleToEdit? {
			...articleToEdit,
			article: {
				...find(articleToEdit, 'article'),
				body: find(articleToEdit, 'body')
			}
		} : null,
	})
};

export const dispatchOnCreateArticlesLayoutsChanged = (layouts) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, layouts})
};

export const dispatchOnCreateArticlesIsSelectingMainImageChanged = (isSelectingMainImage) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, isSelectingMainImage})
};

export const dispatchOnCreateArticlesIsSelectingImagesChanged = (isSelectingImages) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, isSelectingImages,})
};

export const dispatchOnCreateArticlesCreatingNewChanged = (creatingNew) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, creatingNew})
};

export const dispatchOnCreateArticlesSavingDraftChanged = (savingDraft) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, savingDraft})
};

export const dispatchOnCreateArticlesPublishingArticleChanged = (publishingArticle) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, publishingArticle})
};

export const dispatchOnCreateArticlesSavingArticleChanged = (savingArticle) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, savingArticle})
};

export const dispatchOnCreateArticlesIsBodyShowingChanged = (isBodyShowing) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, isBodyShowing})
};


export const dispatchOnCreateArticlesHasUnsavedChangesChanged = (hasUnsavedChanges) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, hasUnsavedChanges})
};

export const dispatchOnCreateArticlesDiscardNewArticle = () => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		...defaultArticleState,
	})
};

export const dispatchOnCreateArticlesDiscardEditingArticle = (props) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		articleToEdit: find(props, 'articleToEditUnsaved') !== undefined ? find(props, 'articleToEditUnsaved') : null,
		articleToEditUnsaved: null,
	})
};

export const dispatchOnCreateArticlesDiscardUnsavedEditingArticle = () => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		articleToEditUnsaved: null,
	})
};

export const dispatchOnCreateArticlesCanShowUnsavedChangesModalChanged = (canShowUnsavedChangesModal) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, canShowUnsavedChangesModal})
};

export const dispatchOnCreateArticlesFormErrors = (errors) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		errors,
	})
};

export const dispatchOnCreateArticlesHasAuthorRightsChanged = (hasAuthorRights) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, hasAuthorRights})
};

export const dispatchOnCreateArticlesShowHasAuthorRightsModalChanged = (showHasAuthorRightsModal) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, showHasAuthorRightsModal})
};

export const dispatchOnCreateArticlesShowAddToPresentation = (showAddToPresentation) => dispatch => {
	dispatch({type: CREATE_ARTICLES_PROPS_CHANGED, showAddToPresentation})
};

export const dispatchOnCreateArticlesSectionsChanged = (sections) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		sections
	})
};

export const dispatchOnCreateArticlesSectionChanged = (section) => dispatch => {
	dispatch({
		type: CREATE_ARTICLES_PROPS_CHANGED,
		section
	})
};





export const articleLayouts = {
	normal: [
		"articles/schools/article_layout_1.twig",
		"articles/schools/article_layout_3.twig"
	],
	gallery: [
		"articles/schools/article_layout_2.twig"
	]
};

export const getArticleMode  = (layout) => {
	return Object.keys(articleLayouts).filter(value => {
		return articleLayouts[value].includes(layout)
	})[0];
};

export const getAllowedArticleLayouts = (mode) => {
	return articleLayouts[mode];
};
